import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  CsobFormMetaDataDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_CSOB } from "../domain";
import { ACTION_GET_CSOB_FORMS_METADATA } from "../GetCsobFormsMetadata";

import { csobHubApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_UPDATE_FORM = "UPDATE_FORM";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

type UpdateFormRequest = {
  id: string;
  data: CsobFormMetaDataDto;
};

const updateForm = async (req: UpdateFormRequest): Promise<void> => {
  const response = await csobHubApi.csobHubControllerUpdateFormMetaData(
    req.id,
    req.data,
  );

  return response.data;
};

export const useUpdateCsobForm = (
  user: UserProfileDto | null,
): {
  updateForm: UseMutateFunction<void, Error, UpdateFormRequest, unknown>;
  updateFormEnabled: boolean;
  isSuccessUpdateForm: boolean;
  isPendingUpdateForm: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_CSOB, ACTION_UPDATE_FORM],
    mutationFn: enabled ? updateForm : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_CSOB, ACTION_GET_CSOB_FORMS_METADATA],
      });
    },
  });

  return {
    updateForm: mutate,
    updateFormEnabled: enabled,
    isSuccessUpdateForm: isSuccess,
    isPendingUpdateForm: isPending,
  };
};
